import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/home/Home.vue'
import Write from '../components/consult/ask/Write.vue'
import List from '../components/consult/ask/List.vue'
import View from '../components/consult/ask/View.vue'
import Secure from '../components/consult/ask/Secure.vue'
import About from '../views/About.vue'
import Product from '../views/Product.vue'
import Consult from '../views/Consult.vue'
import ConsultNotice from '../components/consult/ConsultNotice.vue'
import ConsultAsk from '../components/consult/ConsultAsk.vue'
import AboutCorp from '@/components/about/AboutCorp.vue'
import ProductErp from '@/components/product/ProductErp.vue'
import ProductSol from '@/components/product/ProductSol.vue'
import ProductMes from '@/components/product/ProductMes.vue'
import ProductMobile from '@/components/product/ProductMobile.vue'
import MgnBox from '@/components/product/erp/MgnBox.vue'
import MgnCar from '@/components/product/erp/MgnCar.vue'
import MgnSale from '@/components/product/erp/MgnSale.vue'
import NoticeList from '../components/consult/notice/NoticeList.vue'
import NoticeView from '../components/consult/notice/NoticeView.vue'
import AdminSecure from '../components/consult/adminC/AdminSecure.vue'
import AdminWrite from '../components/consult/adminC/AdminWrite.vue'
import AdminList from '../components/consult/adminC/AdminList.vue'
import AdminView from '../components/consult/adminC/AdminView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '',
    redirect: { name: 'home' }, //기본 url 설정
    component: () => import('@/views/MainPage.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: Home,
      },
    ],
  },
  {
    path: '/',
    // name: 'second',
    component: () => import('@/views/MainPage2.vue'),
    children: [
      {
        path: '', //회사소개
        // name: 'about',
        component: About,
        children: [
          {
            path: 'aboutCorp',
            name: 'aboutCorp',
            components: { changeTab1: AboutCorp },
          },
        ],
      },
      {
        path: '', //제품소개
        // name: 'product',
        component: Product,
        children: [
          { path: 'productErp', name: 'productErp', components: { changeTab2: ProductErp } },
          { path: 'mgnBox', name: 'mgnBox', components: { changeTab2: MgnBox } },
          { path: 'mgnCar', name: 'mgnCar', components: { changeTab2: MgnCar } },
          { path: 'mgnSale', name: 'mgnSale', components: { changeTab2: MgnSale } },
          { path: 'productMes', name: 'productMes', components: { changeTab2: ProductMes } },
          { path: 'productSol', name: 'productSol', components: { changeTab2: ProductSol } },
          { path: 'productMobile', name: 'productMobile', components: { changeTab2: ProductMobile } },
        ],
      },
      {
        path: '', //고객지원
        // name: 'consult',
        component: Consult,
        children: [
          {
            path: 'consultAsk', // name: '',components: { changeTab3: ConsultAsk },
            children: [
              { path: '', name: 'list', components: { listPage: List } },
              { path: 'write', name: 'write', components: { listPage: Write } },
              { path: 'view', name: 'view', components: { listPage: View } },
              { path: 'secure', name: 'secure', components: { listPage: Secure } },
            ],
          },
          {
            path: 'consultNotice',
            // name: '',
            components: { changeTab3: ConsultNotice },
            children: [
              { path: '', name: 'noticeList', components: { listVue: NoticeList } },
              { path: 'noticeView', name: 'noticeView', components: { listVue: NoticeView } },
              { path: 'admin', name: 'admin', components: { listVue: AdminSecure } },
              { path: 'adminList', name: 'adminList', components: { listVue: AdminList }, meta: { requiresAuth: true } },
              { path: 'adminWrite', name: 'adminWrite', components: { listVue: AdminWrite }, meta: { auth: true } },
              { path: 'adminView', name: 'adminView', components: { listVue: AdminView }, meta: { auth: true } },
            ],
          },
        ],
      },
    ],
  },
]
// meta: { auth: true }
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// 라우터 네비게이션 가드(특정 url 접근 제한)
router.beforeEach((to, from, next) => {
  if (to.meta.auth || to.meta.requiresAuth) {
    // console.log('1', to)
    next({ name: 'admin' })
    if (to.meta.requiresAuth) {
      // console.log('2', to)
      to.meta.requiresAuth = false
    } else {
      // console.log('3', to)
      to.meta.auth = false
      next({ name: 'adminList' })
    }
    return
  }
  // console.log('4', to)
  next()
})
export default router
